const PREFIX = "Datasets";
export const SET_IMAGE_CUSTOM_METADATA = `${PREFIX}_SET_IMAGE_CUSTOM_METADATA`;
